/**
 * Regpath Offer
 * Functionaity for a single offer page
 * 
 * Config Options
 * -- none
 */
define('components/regpath-offer',[
    "jquery",
    "utilities",
    "logging",
    "storage",
    "components/offers",
    "application"
], function($, utilities, logging, storage, offers, app) {
    "use strict";

    var _ModuleName = "RegPath Offer Page";
    var _submitLock = false;
    var _config = {
        params: {
            offerId: 'offerId'
        },
        useV2Process: false
    };

    var init = function(data) {
        if(app.getProcessVersionNumber() == '2.0') {
            logging.debug("Using Process Version 2.0");
            _config.useV2Process = true;
        }
    }

    var run = function() {
        logging.debug("Enabling RegPath", _ModuleName);
        
        var offerid = utilities.getParameter(document.URL, _config.params.offerId);
        var $form = $('form');
        
        if(_config.useV2Process) {
            logging.debug("We'll be using the version 2.0 process so no offer id is needed", _ModuleName);
        } else {
            logging.debug("Verifying offer id [" + offerid + "] and form handle", _ModuleName);
        }
        
        if ((offerid || _config.useV2Process) && $form.length) {
            // Make sure we're only working with the first form
            if ($form.length > 1) {
                $form = $($form[0]);
            }
            
            logging.debug("Disabling Default Form Submit", _ModuleName);
            // remove the default form actions, and set up our own.
            $form.unbind();
            $form.submit(function (event) {
                event.preventDefault();
                return false;
            });
        
            logging.debug("Storing Method and Action", _ModuleName);
            // hijack the form post so we can do it for them, and then forward them
            // along to the next page on their offer path.
            var method = $form.attr('method'),
                action = $form.attr('action');
            
            logging.debug("Method: " + method, _ModuleName);
            logging.debug("Action: " + action, _ModuleName);

            logging.debug("Removing Method and Action from Form");
            $form.removeAttr('method').removeAttr('action');
            // huge hack to avoid unbounce error messages in old versions of ie.
            window.alert = function (m) { };
        
            // slightly redefine the form keypress event that unbounce lays on the form. we want
            // the event to bubble up so our handler ultimately catches the event.
            if (window.lp && window.lp.jQuery) {
                // also unbind the submit button 
                window.lp.jQuery('.lp-pom-button').unbind();

                window.lp.jQuery($form).unbind('keypress').keypress(function (e) {
                    if (e.which === 13) {
                        var type = e.target && e.target.nodeName ? e.target.nodeName.toLowerCase() : '';
                        if (type !== 'textarea') {
                            window.lp.jQuery($form).valid();
                        }
                    }
                });
            }
        
            logging.debug("Updating Click Function of Button", _ModuleName);
            var $submit = $('.lp-pom-button');
            $submit.click(function (e) {
                logging.debug("Button was clicked, handling", _ModuleName);
                // If there's already a lock, bail
                if (_submitLock) {
                    logging.warn("Button has already been clicked, please sit tight", _ModuleName);
                    return;
                }

                // Get lock
                _submitLock = true;
        
                // this is to force the form to re-validate and to make sure we don't
                // just go ahead and post if the form has errors. unbounce implements all
                // of their validation with a different jQuery context, so we need to
                // make sure to use their context, as the validator doesn't  exist on our $ context.
                try {
                    if (window.lp && window.lp.jQuery) {
                        if (!window.lp.jQuery('.lp-pom-form form').valid()) {
                            console.error("Form validation failed, form not marked valid.");
                            _submitLock = false;
                            return false;
                        }
                    }

                    console.log('form validation passed');
                }
                catch (ex) {
                    console.error("Something went wrong checking validation.", _ModuleName);
                    _submitLock = false;
                    return false;
                }
        
                try {
                    var $confirmAction = $('input[name=openpageonconfirm]', $form);
                    if ($confirmAction.length) {
                        var url = $confirmAction.attr('value');
                        if (typeof url !== undefined) {
                            window.open(url);
                        }
                    }
                }
                catch (ex) { }
        
                if(action) {
                    action += (action.indexOf('?') < 0 ? '?' : '&') + 'lp-form-submit-method=ajax'
                }
                logging.debug("Submitting Form Data Ourselves to " + action, _ModuleName);
                $.ajax({
                    url: action,
                    type: method,
                    data: $form.serialize(),
                    error: function (xhr, status, error) { try { logging.error('error: ' + error, _ModuleName);  } catch (ex) { } },
                    success: function (data, status, xhr) { try { logging.debug('success!', _ModuleName); } catch (ex) { } },
                    complete: function (xhr, status) 
                    { 
                        if(_config.useV2Process) {
                            logging.debug("Submission was successful", _ModuleName);
                            logging.debug("Submitting Impression Information via Application v2 Processes", _ModuleName);
        
                            app.submitImpression($form, function() {
                                app.notifyParentComplete();
                            })
                        } else {
                            // Load offer path data
                            if(offers.load(offerid)) {
                                // Check if path completed
                                if(offers.isFinalOffer()) {
                                    var landingPage = offers.getLandingPage();
                                    if(landingPage) {
                                        logging.debug("Completed, going to: " + landingPage, _ModuleName);
                                        window.location.href = landingPage;
                                    } else {
                                        logging.error("Completed path but no valid landing page defined", _ModuleName);
                                    }
                                    return;
                                }

                                // If not complete, get next offer
                                var nextOffer = offers.next($form);
                                if(nextOffer) {
                                    window.location.href = nextOffer;
                                } else {
                                    logging.error("Something is wrong with the next offer url", _ModuleName);
                                    _submitLock = false;
                                }
                            } else {
                                logging.error("Something went wrong loading the offer path data", _ModuleName);
                                _submitLock = false;
                            }
                        }
                    }
                });
        
                return false;
            });

            // Show Button if it is hidden
            var styles = $submit.attr('style');
            $submit.attr('style', styles + ';display:inline-block !important;');
        } else {
            logging.error("No Offer ID found or bad form element", _ModuleName);
        }
    }

    return {
        init: init,
        run: run
    }
});
